import { NewsletterProps } from "@omni/types/components/props/newsletter.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { NewsletterContextProvider } from "./context/newsletter.context";

export const Base = ({
    children,
    alignment,
    buttonText,
    helperText,
    isBold,
    link
}: RequireChildrenFor<NewsletterProps>) => {
    return (
        <NewsletterContextProvider
            alignment={alignment}
            buttonText={buttonText}
            helperText={helperText}
            isBold={isBold}
            link={link}
        >
            {children}
        </NewsletterContextProvider>
    );
};
